var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", { staticClass: "tw-w-screen" }, [
    _vm.firebase
      ? _c(
          "div",
          { staticClass: "app-container" },
          [
            _c("Sidebar", {
              class: { mobile: _vm.mobile },
              attrs: { mobile: _vm.mobile }
            }),
            _c(
              "div",
              { staticClass: "main-container", class: { mobile: _vm.mobile } },
              [
                _c("BreadcrumbBar", { attrs: { mobile: _vm.mobile } }),
                _c("router-view", {
                  key: _vm.$route.fullPath,
                  staticClass:
                    "tw-bg-footy-light-grey tw-h-full view-container",
                  class: !_vm.mobile ? "desktop" : "",
                  attrs: { mobile: _vm.mobile }
                }),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.warning
                      ? _c("WarningDialog")
                      : _vm.loading
                      ? _c("LoadingScreen")
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _c("div", { staticClass: "login-container" }, [_c("Login")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }